var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.877,
    height: 19.103,
    viewBox: "0 0 17.877 19.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "csv",
    d: "M34.22,5.621,28.687.088A.3.3,0,0,0,28.477,0H22.21a2.648,2.648,0,0,0-2.645,2.645V7.88H17.243a.814.814,0,0,0-.813.813v4.676a.814.814,0,0,0,.813.813h2.321v2.275A2.648,2.648,0,0,0,22.21,19.1h9.452a2.648,2.648,0,0,0,2.645-2.645V5.832a.3.3,0,0,0-.087-.211Zm-14.966,6.05V10.393a1.26,1.26,0,1,1,2.52,0,.3.3,0,1,1-.6,0,.663.663,0,1,0-1.326,0v1.278a.663.663,0,0,0,1.326,0,.3.3,0,1,1,.6,0,1.26,1.26,0,0,1-2.52,0Zm14.457,4.787a2.051,2.051,0,0,1-2.048,2.049H22.21a2.051,2.051,0,0,1-2.048-2.049V14.183h9.827a.814.814,0,0,0,.813-.813V8.694a.814.814,0,0,0-.813-.813H20.161V2.645A2.051,2.051,0,0,1,22.21.6h5.968V5.234a.9.9,0,0,0,.895.9h4.638Zm-10-5.127a1.976,1.976,0,0,1-.915-.177.972.972,0,0,1-.506-.922,1.1,1.1,0,0,1,1.1-1.1h.476a.946.946,0,0,1,.945.945.3.3,0,0,1-.6,0,.349.349,0,0,0-.349-.348h-.476a.5.5,0,0,0-.5.5c0,.275.062.5.824.5a1.1,1.1,0,1,1,0,2.2h-.476a.946.946,0,0,1-.944-.945.3.3,0,1,1,.6,0,.349.349,0,0,0,.348.349h.476a.5.5,0,1,0,0-1Zm1.751-2.183a.3.3,0,0,1,.377.189l.779,2.348L27.4,9.337a.3.3,0,0,1,.566.188l-1.063,3.2a.3.3,0,0,1-.566,0l-1.062-3.2a.3.3,0,0,1,.189-.377Z",
    transform: "translate(-16.43 0)",
    fill: "#4d4f83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/csv-icon.cb7ce902be377cbd95da590503b07fc9.svg";
export { ForwardRef as ReactComponent };